/**
 * Délais session — source unique pour le plugin d’inactivité et la modale.
 * (Des valeurs trop basses forcent une déconnexion alors que l’utilisateur lit ou réfléchit.)
 */
/** Ms sans aucune activité détectée avant d’afficher la modale d’avertissement */
export const INACTIVITY_WARNING_AFTER_MS = 25 * 60 * 1000; // 25 min

/** Secondes entre l’apparition de la modale et la déconnexion forcée */
export const INACTIVITY_GRACE_PERIOD_SEC = 5 * 60; // 5 min
